import { CheckCheck, Pencil } from "lucide-react";
import ListUIInner from "./ListUIInner";
import { useState } from "react";

const RenderBlock = ({ dynamicId,index,setCurrentContentIndex, block, allBlocks ,currentIndex,setCurrentObject,duplicateContentsItem}) => {
 
 const [isHovered, setIsHovered] = useState(false);
    if (!block) return null;

  // Get block type and content
//   const { blockType, myKey, innerBlocks } = block;

  // Layout block: render its children recursively


    return (<>
    {/* {block?.layoutSettings?.layoutWidth?.value}
      {block?.layoutSettings?.flexDirection} */}
    {(block?.blockType == 'layout')?  <div className={isHovered?"":""} onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}  style={{height:"30px",width:"100%",position:"absolute",top:"-5px",left:"0px",}}>
       {dynamicId==block?.myKey? <div   style={{position:"absolute",top:"-12px",left:"0px",fontSize:"12px",width:"73px",height:"25px",borderRadius:"5px"}}> <div style={{position:"absolute",top:"0px",left:"0px",right:"0px",bottom:"0px"}}><div className="ElementSettingsItem"  style={{display:"flex",justifyContent:"space-between",position:"absolute",top:"-0.1px",left:"-1.08px",fontSize:"12px",width:"60px",height:"15px",paddingRight:"5px",}}> <CheckCheck size={12}  color="#333" /> Selected</div></div></div>:
        
          ""}  
    
       
        {isHovered? <div onClick={()=>{setCurrentObject(block?.myKey,block);setCurrentContentIndex(block?.contentNo)}} className={isHovered?"":""}
            style={{position:"absolute",top:"-9px",width:"27px",height:"28px",}}> <div style={{position:"absolute",top:"1px",left:"0px",right:"0px",bottom:"0px"}}> <div className="ElementSettingsItem"   style={{display:"flex",justifyContent:"space-between",position:"absolute",fontSize:"12px",padding:"3px",left:"-1px"}}> <Pencil size={18}  color="#333" /></div></div> </div>:""}
    </div>:""}
    
        <div
                                       
                                      
        key={block?.myKey}
        style={{
          display: 'flex', 
         border:isHovered?"2px solid rgba(144, 202, 249,1)":"2px solid transparent",
          borderRadius:"10px",
         width:block?.layoutSettings?.layoutWidth?.value+block?.layoutSettings?.layoutWidth?.resolution,
    // height:block?.layoutSettings?.layoutHeight?.value+block?.layoutSettings?.layoutHeight?.resolution,
    flexDirection:block?.layoutSettings?.flexDirection,
    justifyContent:block?.layoutSettings?.justifyContent,
    // alignItems:block?.layoutSettings?.alignItems,
    gap:block?.layoutSettings?.gap,
    flexWrap:block?.layoutSettings?.flexWrap,
    alignContent:block?.layoutSettings?.alignContent,
          marginBottom: 10,
        }}
        className="hideFlexStylesXs "
      >
 
     { (block?.blockType !== 'layout')?
    
    <div  
      key={block?.myKey}
      
    >
     
       <ListUIInner   
                                    CurrentObject ={block} 
                                    currentIndex={currentIndex} dynamicId={dynamicId} 
                                         setCurrentObject={(currentItemKey,currentItem)=>{setCurrentObject(currentItemKey,currentItem);setCurrentContentIndex(index)}}
                                       
                                         duplicateContentsItem={(item)=>{duplicateContentsItem(item)}}
                                  /> 
    </div>:""}
     {/* <div > {block?.myKey}</div> */}
        {block?.innerBlocks?.map((inner) => {
          const childBlock = allBlocks.find((b) => b?.myKey === inner?.myKey);
          return <RenderBlock dynamicId={dynamicId} index={index} setCurrentContentIndex={()=>{setCurrentContentIndex(childBlock?.contentNo)}} key={inner?.myKey} block={childBlock} allBlocks={allBlocks}  currentIndex={currentIndex}
          setCurrentObject={(currentItemKey,item)=>{setCurrentObject(currentItemKey,item) }}
          duplicateContentsItem={(item)=>{duplicateContentsItem(item)}} />;
        })}
      </div>
        </>);
  
  // Other block types (image, video, etc.)
  

};
export default RenderBlock;